var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 310,
    height: 142,
    viewBox: "0 0 310 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M186.523 141.842C158.448 140.012 149.305 101.656 132.963 86.4821C116.621 71.3078 81.2693 82.1357 73.6124 40.8066C68.4698 13.203 45.5372 11.9829 26.3759 1.84129C15.9382 -3.68705 3.3291 3.90012 3.3291 15.7193V141.842H186.523Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 228.362,
    y: 140.419,
    width: 81.6368,
    height: 1.42286,
    fill: "#B3C1D2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M181.365 85.1496C174.561 97.0216 192.125 109.516 180.475 115.963C172.16 120.543 164.246 128.858 154.597 127.791C144.948 126.679 146.86 103.736 146.86 103.736L170.782 79.4136L181.365 85.1496Z",
    fill: "#864C3C"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    x: 3.01758,
    y: 140.419,
    width: 90.3519,
    height: 1.42286,
    fill: "#B3C1D2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M88.5213 44.4201C88.1656 43.175 88.1656 41.7966 88.4769 40.5516C89.0104 38.5063 87.7654 36.372 85.7201 35.8384L46.4134 25.1225C44.1457 24.4999 42.8563 27.6125 44.9461 28.7685L62.5096 38.5507L64.0658 47.7104L89.9887 49.7558L88.5213 44.4201Z",
    fill: "#FDC068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M121.248 134.105C121.292 135.795 121.559 137.44 121.915 139.085L79.1399 137.44L68.4684 74.0779L66.9121 64.6959L64.0664 47.7104L89.9892 49.7558L91.1008 53.7576L94.1689 65.3184L103.595 100.534L123.782 98.9336C122.76 100.668 121.959 102.535 121.381 104.447C120.492 110.361 119.914 115.919 120.358 121.833C120.581 125.968 121.07 130.014 121.248 134.105Z",
    fill: "#4C7DE0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    d: "M88.834 91.419C92.2965 91.419 95.1034 88.6121 95.1034 85.1495C95.1034 81.687 92.2965 78.8801 88.834 78.8801C85.3714 78.8801 82.5645 81.687 82.5645 85.1495C82.5645 88.6121 85.3714 91.419 88.834 91.419Z",
    fill: "#94B1EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M77.9403 68.6977C77.9403 72.1214 75.139 74.9672 71.6708 74.9672C70.5592 74.9672 69.4031 74.6559 68.4693 74.0779L66.9131 64.6959C69.1363 62.0725 73.0937 61.7167 75.7171 63.94C77.1399 65.096 77.9403 66.8746 77.9403 68.6977Z",
    fill: "#94B1EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M94.1261 65.3629C91.1914 67.1859 87.323 66.2522 85.4999 63.3175C83.6769 60.3828 84.6107 56.5144 87.5453 54.6914C88.5235 54.0689 89.6796 53.7576 90.8802 53.7576H91.058L94.1261 65.3629Z",
    fill: "#94B1EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    d: "M153.974 114.585L149.305 97.8664C147.216 91.2857 150.862 84.2603 157.398 82.1704C163.979 80.0806 171.004 83.7267 173.094 90.263C173.138 90.3519 173.138 90.4408 173.138 90.5298L177.496 106.137L153.974 114.585Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    d: "M177.496 106.137L180.742 117.564L216.18 124.901C220.76 125.612 223.917 129.881 223.206 134.505C222.583 138.596 219.071 141.575 214.935 141.619L171.894 141.797C167.136 142.109 157.665 139.619 155.842 135.217L155.486 134.327L153.975 114.585L177.496 106.137Z",
    fill: "#FDC068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    d: "M120.004 99.2893C104.708 94.5316 90.3904 104.225 104.708 128.947C110.711 139.307 125.918 140.197 125.918 140.197L120.004 99.2893Z",
    fill: "#4C7DE0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    d: "M125.651 140.241L124.984 140.419C120.537 141.397 115.957 141.931 111.422 141.931L87.4112 141.886H74.9611H66.0682C60.9993 141.886 56.4639 138.729 54.7298 134.016C53.885 131.748 52.8623 129.125 51.7507 126.235C50.3723 122.678 48.816 118.72 47.2153 114.541C42.6354 102.802 37.2552 89.4626 33.0756 78.8801C31.5193 74.9672 30.0964 71.4545 28.9404 68.5643C26.8505 63.3619 25.5166 60.116 25.5166 60.116L50.9948 56.0698L57.3532 67.008L62.7779 76.2567L77.051 100.712L120.359 101.601L125.651 140.241Z",
    fill: "#4C7DE0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    d: "M47.7041 50.3783C47.0816 49.2667 46.6815 47.9772 46.637 46.6878C46.5925 44.5535 44.8139 42.8638 42.7241 42.8638L1.99463 42.8638C-0.361994 42.8638 -0.762174 46.1987 1.50552 46.7767L21.0254 51.5789L25.5164 60.0271L50.9945 55.9808L47.7041 50.3783Z",
    fill: "#FDC068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    d: "M163.979 79.4136C164.779 80.3029 165.668 81.1033 166.38 82.1704C168.247 84.9272 168.292 85.5497 172.738 92.0415C178.474 100.49 170.337 110.85 161 112.94C157.887 113.651 156.064 115.03 155.041 117.12C149.172 129.347 141.213 132.904 136.188 136.106C132.987 138.107 129.385 139.485 125.695 140.197L120.048 99.2893C127.785 94.2203 131.609 83.1042 140.946 78.0797C147.26 74.6115 159.488 74.4781 163.979 79.4136Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    d: "M155.53 92.7974L154.419 90.3074C152.951 86.9726 153.885 83.0152 156.642 80.6586L172.871 70.9209L177.496 84.8383L166.202 94.665C163.712 97.2884 159.621 97.3773 156.953 94.8873C156.375 94.3092 155.886 93.5978 155.53 92.7974Z",
    fill: "#FDC068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    d: "M165.401 81.5034L168.425 92.664L176.117 85.9944L165.401 81.5034Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    d: "M179.764 87.6395H179.586C169.849 88.0842 161.623 80.5697 161.178 70.832L160.956 65.9853C160.6 58.3819 166.469 51.9345 174.073 51.6233C174.295 51.6233 174.473 51.6233 174.695 51.6233C182.076 51.6233 188.124 57.4037 188.479 64.7848L188.568 67.2303L188.702 70.2984L189.013 77.5016C189.324 82.8374 185.189 87.4172 179.764 87.6395Z",
    fill: "#FDC068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    d: "M188.745 70.2539C187.9 70.1206 187.322 69.3202 187.456 68.4309C187.545 67.8084 187.989 67.3193 188.612 67.1859L188.745 70.2539Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M185.411 73.6777C185.233 73.6777 185.1 73.6332 185.011 73.4554C184.833 73.2331 184.922 72.9218 185.144 72.7884L186.345 71.9881C186.478 71.8547 186.522 71.7213 186.522 71.5879C186.522 71.41 186.478 71.2766 186.345 71.1877L184.299 68.92C184.121 68.7421 184.121 68.3864 184.344 68.253C184.522 68.0752 184.877 68.0752 185.011 68.2975L187.056 70.5652C187.367 70.8764 187.456 71.2766 187.456 71.6768C187.412 72.077 187.278 72.4772 186.967 72.744L186.878 72.7884L185.678 73.5888C185.589 73.6332 185.5 73.6777 185.411 73.6777Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    d: "M184.076 78.7911C183.32 78.7911 182.564 78.4799 181.808 77.8129C181.63 77.635 181.586 77.3238 181.764 77.1459C181.941 76.9681 182.253 76.9236 182.431 77.1015C183.186 77.724 183.853 77.9463 184.431 77.8129C185.232 77.635 185.632 76.8347 185.676 76.8347C185.81 76.6124 186.077 76.5234 186.299 76.6568C186.521 76.7902 186.61 77.057 186.477 77.2793C186.432 77.3238 185.854 78.4799 184.565 78.7467C184.387 78.7911 184.254 78.7911 184.076 78.7911Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_2",
    d: "M180.075 70.6986C180.934 70.6986 181.631 70.0018 181.631 69.1423C181.631 68.2828 180.934 67.5861 180.075 67.5861C179.215 67.5861 178.519 68.2828 178.519 69.1423C178.519 70.0018 179.215 70.6986 180.075 70.6986Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    d: "M174.161 50.2894C174.206 56.2476 183.187 63.273 188.657 63.2286C188.612 63.1841 188.301 49.9337 174.161 50.2894Z",
    fill: "#864C3C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    d: "M176.473 50.2449C176.473 50.2449 180.43 77.0125 161.978 78.8801C161.978 78.8801 160.866 70.2095 160.822 63.8511C160.777 57.4926 165.046 49.5779 176.473 50.2449Z",
    fill: "#864C3C"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    x: 156.776,
    y: 136.862,
    width: 38.8175,
    height: 4.84663,
    fill: "#F9D5FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    d: "M131.341 113.607L129.652 92.4417C129.474 85.6387 134.899 79.9472 141.746 79.8138C148.549 79.636 154.241 85.0606 154.374 91.9082C154.374 91.9526 154.374 92.086 154.374 92.1305L154.774 111.962L131.341 113.607Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    d: "M154.819 111.962V122.767L184.299 125.479C188.834 125.657 192.391 129.436 192.258 133.927C192.124 137.929 189.056 141.308 185.099 141.797H140.101C135.61 140.33 132.497 136.195 132.453 131.482V130.548L131.386 113.607L154.819 111.962Z",
    fill: "#FDC068"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    d: "M192.124 132.771C191.902 132.771 191.68 132.593 191.635 132.371C191.013 128.769 187.945 126.057 184.254 125.924L154.952 122.989C154.685 122.944 154.507 122.722 154.552 122.455C154.596 122.188 154.819 122.011 155.085 122.055L184.343 124.99C188.434 125.123 191.902 128.191 192.569 132.193C192.613 132.46 192.436 132.727 192.169 132.727C192.169 132.771 192.124 132.771 192.124 132.771Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    d: "M199.194 96.7103H241.391C242.903 96.6659 244.148 97.8664 244.148 99.3337C244.148 99.5116 244.148 99.645 244.103 99.7784L239.612 138.685C239.39 140.419 237.923 141.753 236.144 141.753H190.924L195.77 99.7784C195.993 98.0887 197.46 96.7993 199.194 96.7103Z",
    fill: "#F9D5FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_3",
    d: "M221.722 122.015C223.419 120.413 223.632 117.885 222.199 116.367C220.765 114.849 218.229 114.917 216.532 116.519C214.836 118.121 214.623 120.65 216.056 122.167C217.489 123.685 220.026 123.617 221.722 122.015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    d: "M101.507 101.601H76.6958L72.0715 93.1532C71.9381 92.9308 72.027 92.6196 72.2493 92.5307C72.4716 92.3973 72.7829 92.4862 72.8718 92.7085L77.2293 100.623H101.418C101.685 100.623 101.907 100.846 101.907 101.112C101.907 101.379 101.729 101.601 101.507 101.601Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    d: "M171.003 102.135C170.781 102.002 170.47 102.135 170.381 102.357C168.247 106.804 164.156 112.495 156.819 114.274L154.818 114.674C154.818 114.763 154.818 114.852 154.863 114.941C154.863 115.163 154.863 115.43 154.863 115.652C154.907 115.652 154.907 115.652 154.952 115.652L157.042 115.208C164.734 113.296 169.003 107.382 171.27 102.757C171.359 102.535 171.226 102.268 171.003 102.135Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    d: "M154.996 123.033C154.729 123.033 154.507 122.855 154.507 122.544L154.106 101.468C154.106 101.201 154.284 100.979 154.596 100.979C154.862 100.979 155.085 101.157 155.085 101.468L155.485 122.544C155.529 122.811 155.263 123.033 154.996 123.033C154.996 123.033 155.04 123.033 154.996 123.033Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    d: "M162.645 56.7367C158.332 63.4953 155.442 65.4962 142.236 65.0516C108.443 64.0289 96.5706 93.3755 114.001 110.05C131.386 126.768 144.681 112.629 148.861 98.4444C153.085 84.2603 160.244 80.6142 166.647 77.6795C171.805 75.3229 165.624 57.7594 165.624 57.7594L162.645 56.7367Z",
    fill: "#864C3C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    d: "M151.44 123.611C151.218 123.611 150.996 123.434 150.951 123.211C150.907 122.944 151.085 122.678 151.351 122.678L154.686 122.188C154.953 122.144 155.22 122.322 155.22 122.589C155.264 122.855 155.086 123.122 154.82 123.122L151.485 123.611C151.529 123.611 151.485 123.611 151.44 123.611Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    d: "M64.7334 47.7549L89.9448 49.6669C90.5228 49.7113 91.0564 50.1115 91.1898 50.6895L92.3459 54.8247C92.5682 55.5806 92.1235 56.3365 91.3676 56.5589C91.1898 56.6033 91.0564 56.6033 90.923 56.6033L65.178 55.4472C64.5111 55.4028 63.933 54.9137 63.8441 54.2467L63.2216 49.3556C63.1327 48.5997 63.6662 47.8883 64.4221 47.7993C64.5111 47.7549 64.6445 47.7549 64.7334 47.7549Z",
    fill: "#4C7DE0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    d: "M26.4069 59.8937L50.8179 55.6251C51.7072 55.4473 52.552 55.9364 52.9522 56.6923L54.5085 59.7159C55.042 60.6941 54.6419 61.8946 53.6192 62.4282C53.4413 62.5171 53.2635 62.6061 53.0856 62.6061L28.4523 67.3193C27.474 67.4972 26.5403 66.9636 26.1846 66.0743L24.8506 62.6061C24.4505 61.5834 24.984 60.4273 26.0512 59.9827C26.1846 59.9382 26.2735 59.9382 26.4069 59.8937Z",
    fill: "#4C7DE0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    d: "M55.7511 120.365C55.7511 122.944 54.1948 125.257 51.7492 126.19C50.3708 122.633 48.8146 118.676 47.2139 114.496C50.4153 113.251 54.0614 114.852 55.3064 118.053C55.6177 118.809 55.7511 119.565 55.7511 120.365Z",
    fill: "#94B1EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_4",
    d: "M50.9961 101.112C54.4586 101.112 57.2656 98.3053 57.2656 94.8428C57.2656 91.3803 54.4586 88.5733 50.9961 88.5733C47.5335 88.5733 44.7266 91.3803 44.7266 94.8428C44.7266 98.3053 47.5335 101.112 50.9961 101.112Z",
    fill: "#94B1EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    d: "M39.8787 72.6105C39.8787 76.0343 37.0774 78.88 33.6537 78.88C33.4758 78.88 33.2535 78.88 33.0756 78.8356C31.5194 74.9227 30.0965 71.41 28.9404 68.5198C31.2081 65.8964 35.1655 65.6296 37.7444 67.8973C39.0783 69.0978 39.8787 70.832 39.8787 72.6105Z",
    fill: "#94B1EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    d: "M62.7328 76.1233C61.0876 79.1469 57.3081 80.2585 54.24 78.6133C51.172 76.9681 50.1048 73.1886 51.75 70.1206C52.8616 68.0752 54.9515 66.8302 57.2636 66.8302H57.397L62.7328 76.1233Z",
    fill: "#94B1EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_5",
    d: "M71.7148 119.165C75.1774 119.165 77.9843 116.358 77.9843 112.895C77.9843 109.433 75.1774 106.626 71.7148 106.626C68.2523 106.626 65.4453 109.433 65.4453 112.895C65.4453 116.358 68.2523 119.165 71.7148 119.165Z",
    fill: "#94B1EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    d: "M87.455 141.086C87.455 141.353 87.455 141.575 87.4105 141.842H74.9605C74.916 141.62 74.916 141.353 74.916 141.13C74.916 137.707 77.7173 134.861 81.1855 134.861C84.6537 134.861 87.455 137.662 87.455 141.086Z",
    fill: "#94B1EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_6",
    d: "M97.1035 117.075C100.566 117.075 103.373 114.268 103.373 110.806C103.373 107.343 100.566 104.536 97.1035 104.536C93.6409 104.536 90.834 107.343 90.834 110.806C90.834 114.268 93.6409 117.075 97.1035 117.075Z",
    fill: "#94B1EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_7",
    d: "M112.311 137.573C115.773 137.573 118.58 134.766 118.58 131.304C118.58 127.841 115.773 125.034 112.311 125.034C108.848 125.034 106.041 127.841 106.041 131.304C106.041 134.766 108.848 137.573 112.311 137.573Z",
    fill: "#94B1EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    d: "M91.8115 57.2258L65.3107 55.9808C65.0439 55.9808 64.8216 55.7585 64.866 55.4473C64.866 55.1805 65.0884 54.9581 65.3996 55.0026L91.9005 56.2476C92.1673 56.2476 92.3896 56.4699 92.3451 56.7812C92.3007 57.0035 92.0783 57.2258 91.8115 57.2258Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    d: "M28.452 67.8528C28.2297 67.8528 28.0518 67.675 27.9629 67.4527C27.9184 67.1859 28.0963 66.9191 28.363 66.8746L54.2859 61.9835C54.5526 61.9391 54.8194 62.1169 54.8639 62.3837C54.9084 62.6505 54.7305 62.9173 54.4637 62.9617L28.5409 67.8084C28.5409 67.8528 28.4964 67.8528 28.452 67.8528Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    d: "M236.697 22.4844L266.321 17.202L248.274 37.2668L236.697 22.4844Z",
    fill: "#E6ECF7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    d: "M266.32 17.202L240.934 27.6021L243.478 31.1419L266.32 17.202Z",
    fill: "#CAD9EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    d: "M240.934 27.6021L240.262 34.8175L243.478 31.1419L240.934 27.6021Z",
    fill: "#CAD9EB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 59.807,
    y1: 0.864327,
    x2: 1.04732,
    y2: 121.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD8A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 163.751,
    y1: 56.7355,
    x2: 103.174,
    y2: 78.1477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8809A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FFE651"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEC3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 155.011,
    y1: 61.6888,
    x2: 109.489,
    y2: 84.7455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8809A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FFE651"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEC3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 155.621,
    y1: 46.526,
    x2: 97.4542,
    y2: 66.5414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8809A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FFE651"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEC3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileWarning);
export default __webpack_public_path__ + "static/media/mobile_warning.d424cb6d554a7ca2257e5e3499b8946c.svg";
export { ForwardRef as ReactComponent };